<template>
  <div class="contain">
    <!-- 标题 -->
    <div class="title-container">
      <div class="main-title">
        訂閱付費紀錄 <span class="en-title">Subscribe Record</span>
      </div>
      <div class="color-dot-container">
        <span class="color-dot dot-red"></span>
        <span class="color-dot dot-orange"></span>
        <span class="color-dot dot-yellow"></span>
      </div>
    </div>

    <!-- ====================== PC 表格 ====================== -->
    <div class="table-box desktop-only">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="orderNo" :label="'交易編號\nTransaction number'" align="center" min-width="240"> </el-table-column>
        <el-table-column prop="payedAt" :label="'付費日期\nPayment date'" align="center" min-width="180" :formatter="dateFormatter"> </el-table-column>
        <el-table-column prop="studentQuantity" :label="'訂閱學生數目\nSubscribed Number'" align="center" min-width="160"> </el-table-column>
        <el-table-column prop="payPrice" :label="'總計\nTotal'" align="center" min-width="180" :formatter="priceFormatter"> </el-table-column>
        <el-table-column min-width="200" align="center">
          <template slot-scope="scope">
            <el-button class="detail-button" @click="purchaseDetail(scope.row)">查閱 Check</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- ====================== 手机卡片模式 ====================== -->
    <div class="card-list mobile-only">
      <div class="order-card" v-for="item in tableData" :key="item.id">
        <div class="card-row">
          <label>交易編號:</label>
          <span>{{ item.orderNo || '---' }}</span>
        </div>
        <div class="card-row">
          <label>付費日期:</label>
          <span>{{ dateFormatter(item) }}</span>
        </div>
        <div class="card-row">
          <label>學生數目:</label>
          <span>{{ item.studentQuantity || 0 }}</span>
        </div>
        <div class="card-row">
          <label>總計:</label>
          <span class="price">{{ priceFormatter(item) }}</span>
        </div>
        <div class="card-btn">
          <el-button type="primary" plain size="small" @click="purchaseDetail(item)">
            查閱 Check
          </el-button>
        </div>
      </div>

      <div class="empty" v-if="tableData.length === 0">
        暫無訂閱記錄
      </div>
    </div>

    <!-- 分頁 -->
    <div class="pagination-container">
      <Pagination
          v-show="total > 0"
          :small="isMobile"
          :total="total"
          :autoScroll="false"
          :page.sync="listQ._page"
          :limit.sync="listQ._limit"
          @pagination="getOrders"
          layout="pager"
      />
    </div>
  </div>
</template>

<script>
import { setUserInfo, getUserInfo } from "@/utils/auth";
import { getOrders } from "@/api/order";
import { formatDate } from "@/filters";
import Pagination from "@/components/Pagination";

export default {
  components: { Pagination },
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      total: 0,
      listQ: { _page: 1, _limit: 10 },
      tableData: [],
      isMobile: false,
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    if (getUserInfo("purchase")) {
      this.listQ = JSON.parse(getUserInfo("purchase"));
    }
    this.getOrders();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    getOrders() {
      let form = {
        parentId: this.detail.id,
        status: 1,
        _page: this.listQ._page - 1,
        _limit: this.listQ._limit,
      };
      getOrders(form).then((v) => {
        setUserInfo("purchase", JSON.stringify(this.listQ));
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    dateFormatter(row) {
      return formatDate(row.payedAt) || "---";
    },
    priceFormatter(row) {
      return row.payPrice ? `HKD $${row.payPrice.toLocaleString()}` : "HKD $0";
    },
    purchaseDetail(row) {
      this.$router.push({ path: `/purchaseDetail/${row.id}` });
    },
  },
};
</script>

<style lang="scss" scoped>
$phone: 767px;
$pc: 768px;

.contain {
  padding: 1rem 3vw;
  @media (min-width: $pc) {
    padding: 2.25rem 5vw;
  }
}

/* 标题 */
.title-container {
  margin-bottom: 1rem;
  .main-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #b62d2e;
    @media (min-width: $pc) {
      font-size: 2rem;
    }
  }
  .color-dot-container {
    display: flex;
    margin-top: 0.5rem;
    .color-dot {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      margin-right: 0.8rem;
      @media (min-width: $pc) {
        width: 1rem;
        height: 1rem;
        margin-right: 1rem;
      }
    }
    .dot-red { background: #b62d2e; }
    .dot-orange { background: #de5934; }
    .dot-yellow { background: #f1aa55; }
  }
}

/* 显示隐藏 */
.desktop-only {
  display: none;
  @media (min-width: $pc) {
    display: block;
  }
}
.mobile-only {
  display: block;
  @media (min-width: $pc) {
    display: none;
  }
}

/* 表格样式还原 */
.table-box {
  padding: 1.25rem 0;
}
.detail-button {
  border: 1px solid #fcc03a;
  font-weight: bold;
  color: #444;
  border-radius: 26px;
  padding: 0.75rem 2.25rem;
}

/* ====================== 手机卡片样式 ====================== */
.card-list {
  margin-top: 0.5rem;
}
.order-card {
  background: #fff;
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 0.8rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-left: 4px solid #b62d2e;
}
.card-row {
  display: flex;
  padding: 0.4rem 0;
  font-size: 15px;
  label {
    min-width: 6rem;
    font-weight: 500;
    color: #666;
  }
  span {
    color: #333;
  }
  .price {
    color: #b62d2e;
    font-weight: bold;
  }
}
.card-btn {
  margin-top: 0.6rem;
  text-align: right;
}
.empty {
  text-align: center;
  padding: 2rem 0;
  color: #999;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
</style>